import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';

import { useSelector } from 'react-redux';
import { groupsService } from '@app/services';
import { useDebounce, searchMinimumLength } from '@app/helpers';
import { Order, IGroup } from '@app/models';
import { PasslyAutoComplete } from '@app/componentsV2';

interface IReceivedData {
    returnGroup: Function;
}

const InitialGroupForMigratorComponent = (props: IReceivedData) => {
    const { translation } = useTypedTranslation();

    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const organizationFilter = useSelector((state: any) => state.organizationSelect.selectedOrganization);
    const [filterText, setFilterText] = useState('');
    const [groups, setGroups] = useState<IGroup[]>([]);
    const [loaded, setLoaded] = useState<boolean>(false);
    const debouncedSearch = useDebounce(filterText, 500);

    useEffect(() => {
        if (debouncedSearch === '' && loaded) {
            getGroupsInitial();
        } else if (loaded) {
            getGroupsByFilter(true);
        }

    }, [organizationFilter]);

    useEffect(() => {
        if (debouncedSearch === '') {
            getGroupsInitial();
        }
        else if (debouncedSearch.length >= searchMinimumLength) {
            getGroupsByFilter();
        }
    }, [debouncedSearch]);

    const getGroupsByFilter = (orgChanged: boolean = false) => {
        if (orgChanged) {
            // clear out options
            setGroups([]);
        } else if (filterText !== '') {
            groupsService.getGroupsDTOFilter('name', Order.asc, organizationFilter, filterText, handleError, handleGroupsList);
        }
    };

    const getGroupsInitial = () => {
        groupsService.getAllGroupsDTOInitial(Order.asc, organizationFilter).then(handleGroupsList).catch(handleError);
    };

    const handleGroupsList = (response: any) => {
        setLoaded(true);
        const results: IGroup[] = response;

        if (results) {
            setGroups(results);
        }
    };

    const handleError = (errorResponse: any) => {
        if (errorResponse.data.error) {
            setErrorMessage(errorResponse.data.error.message);
        } else if (errorResponse.message) {
            setErrorMessage(errorResponse.message);
        } else {
            setErrorMessage(translation('GENERIC_ERROR'));
        }
    };

    const groupSelected = (e: any) => {
        const chosen = e.target.value;

        if (chosen && chosen.Id !== '') {
            props.returnGroup(chosen.Id);
        } else {
            props.returnGroup('');
        }
    };

    return (
        <>
            <PasslyAutoComplete
                className='passwordPolicy'
                items={groups}
                onChange={groupSelected}
                id='groupSelect'
                name='passwordPolicy'
                label={translation('ON_PREM_MIGRATOR_INITIAL_GROUP')}
                field='Name'
                dropdown={true}
                appendTo={document.body}
            />

            {errorMessage && <div className='modal__error'>{errorMessage}</div>}
        </>
    );
};

export default InitialGroupForMigratorComponent;
